<template>
    <div class="rating-bar">
        <div class="rating-box">
            <p class="rating-text">総合評価</p>
        </div>
        <div class="stars">
            <span class="star filled">★</span>
            <span class="star filled">★</span>
            <span class="star filled">★</span>
            <span class="star filled">★</span>
            <span class="star half-filled">★</span>
        </div>
        <p class="rating-point">4.2pt</p>
    </div>
</template>

<style scoped>
.rating-bar {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 20px;
    margin: 0;
    margin-top: 0;
    padding-left: 15px;
}

.rating-box {
    border: 1px solid #ccc;
    padding: 5px 10px;
    border-radius: 5px;
}

.rating-text {
    margin: 0;
    font-size: 14px;
    color: #555;
}

.stars {
    color: #ffc107;
    font-size: 18px;
}

.star {
    font-size: 22px;
}

.rating-point {
    font-size: 20px;
    font-weight: bold;
    color: #d9534f;
    margin-left: 5px;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .rating-bar .rating-text {
        font-size: 0.8rem;
    }

    .rating-point {
        font-size: 1.1rem;
    }

    .stars span {
        font-size: 1.3rem;
    }
}
</style>